export const FLAG_GETTING_FREE_OF_CHARGE_RULES =
  'FLAG_GETTING_FREE_OF_CHARGE_RULES';
export const GET_FREE_OF_CHARGE_RULES = 'GET_FREE_OF_CHARGE_RULES';
export const CLEAR_FREE_OF_CHARGE_RULES = 'CLEAR_FREE_OF_CHARGE_RULES';
export const GET_FREE_OF_CHARGE_RULE = 'GET_FREE_OF_CHARGE_RULE';
export const CLEAR_FREE_OF_CHARGE_RULE = 'CLEAR_FREE_OF_CHARGE_RULE';
export const FLAG_FREE_OF_CHARGE_RULE_ACTIVITY =
  'FLAG_FREE_OF_CHARGE_RULE_ACTIVITY';
